import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { termsAndConditonsAUURL, getTermsAndConditionsDetailsURl, GET_TERMS_AND_CONDITIONS_DETAILS, TERMS_AND_CONDITIONS_AU, headers } from "../../utils/constants"
import moment from 'moment';

export const terms_and_Conditions_AU_action = (userID, OrderID, AdditionalInformation, IsAgree, isEdit) => async (dispatch) => {
    console.log('here')
    try {
        const mapdata = {
            userID: parseInt(userID),
            OrderID: OrderID,
            AdditionalInformation: AdditionalInformation,
            IsAgree: IsAgree,
            isEdit: isEdit,
        }
        console.log("data----------", mapdata)
        const res = await axiosPost(termsAndConditonsAUURL, mapdata, headers);

        dispatch({
            type: TERMS_AND_CONDITIONS_AU,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_Terms_and_Conditions_details_action = (userID, OrderID) => async (dispatch) => {
    try {
        const mapdata = {
            userID: userID,
            OrderID: OrderID,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getTermsAndConditionsDetailsURl, mapdata, headers);

        dispatch({
            type: GET_TERMS_AND_CONDITIONS_DETAILS,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};